<template>
  <div class="col-6 col-md-0 d-block d-lg-none border-r border-b">
    <div
      class="filter-toggle"
      v-if="getFilter.length > 0"
    >
      <button
        class="fiter-toggle-btn"
        id="filter-btn"
        @click.prevent="showFilter"
								data-test="filterButtonBtn"
      >
        <i class="fas fa-filter"
											data-test="filterButtonIcon"
											id="filterButtonIcon"></i>
        Filter
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
	name: 'filter-button',
	mounted () {
		$('.fiter-toggle-btn').on('click', () => {
			if ($('.filter-sidebar').hasClass('show')) {
				$('.filter-sidebar').removeClass('show')
			} else {
				$('.filter-sidebar').addClass('show')
				document.body.classList.add('stop-scroll')
			}
		})
	},
	computed: {
		...mapGetters('category', ['getActiveCategories']),
		...mapGetters('filters', [
			'getFilters',
			'getFilter',
			'getFilterId',
			'getPriceRange',
			'getKeyWord',
			'emptyFilters'
		])
		// categoryData () {
		//     this.getActiveCategories.findIndex(this.$route.query.category);
		// }
	},
	methods: {
		showFilter () {
			const contentId = document.getElementById('filterOverlayMobile')
			// Toggle
			if (contentId.style.display === 'none') {
				contentId.style.display = 'block'
			}
			$('.show_hide').show()
		}
	}
}
</script>
